/**
 * Format a person's display name from its parts, including the middle name/initial and generational
 * suffix — which the collapsed name labels on the offer/policy applicant + driver cards previously
 * omitted (they rendered only `firstName lastName`), so a migrated middle initial ("JOHN E TAYLOR")
 * or suffix ("ROBERT MOORE JR") did not display on the policy. #33890
 *
 * Empty/missing parts are dropped without leaving double spaces. Returns '' for a null/undefined
 * person.
 */
export const formatPersonName = (person) => {
  if (!person) {
    return '';
  }
  const { firstName, middleName, lastName, suffix } = person;
  return [firstName, middleName, lastName, suffix]
    .map((part) => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' ');
};
